import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const marks = {
  0: <span style={{ whiteSpace: 'nowrap' }}>Generally Related</span>,
  50: <span style={{ whiteSpace: 'nowrap' }}>Closely Related</span>,
  100: <span style={{ whiteSpace: 'nowrap' }}>Nearly Identical</span>,
};

const MatchBiasSlider = ({ matchSliderValue, onMatchSliderChange, disabled }) => {
  return (
    <div className="match-bias-slider">
      <Slider
        marks={marks}
        step={1}
        value={matchSliderValue}
        min={0}
        max={100}
        onChange={onMatchSliderChange}
        disabled={disabled}
        ariaLabelForHandle={() => 'Match flexibility'}
        ariaValueTextFormatterForHandle={(val) => `${val}`}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default MatchBiasSlider;